import React, { useEffect, useState } from 'react';
import { getdata, getdatanoauth, WAITINGGIF, sendwhatsappmessageapi } from '../../util/global';
import TableBill from './TableBill';
import KitLoader from '../../components/kitsters/KitLoader';

const BillAttachmentCheck = () => {
  const [billdata, setbilldata] = useState([]);
  const [loading, setLoading] = useState(true);
  const params = new URLSearchParams(window.location.search);
  


  const fetchdata = async () => {
    const adminuserid = window.APPUSER?.user?.token ? window.APPSETTING.adminuserid : params.get('adminuserid');

    let data = await getdatanoauth({ zohodatatype: 'bills', _adminuserid: adminuserid }, '/zohodatanoauth');
    setbilldata(data.data);
    setLoading(false);
  };


  useEffect(() => {
    fetchdata();
  }, []);

  return (
    <div className="content-area" style={{ position: 'relative', minHeight: 'calc(100vh - 140px)' }}>
      {loading && <KitLoader />}
      <h3 style={{ marginBottom: '16px' }}>Bills without attachment | Problem Count: {billdata.length}  </h3>
      <TableBill billdata={billdata} />
    </div>
  );
};

export default BillAttachmentCheck;
